var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", { staticClass: "table table-responsive" }, [
      _c("tbody", [
        _c("tr", [
          _c("th", { staticStyle: { "border-top": "none" } }, [
            _vm._v(_vm._s(_vm.$t("company_name")))
          ]),
          _vm._v(" "),
          _c("td", { staticStyle: { "border-top": "none" } }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.saveGet(_vm.licence, "-", "licenseeName")) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _vm.saveGet(_vm.licence, "-", "licenceKey").length < 12
          ? _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("licensee_gln")))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.mainGln))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.$t("address")))]),
          _vm._v(" "),
          _c(
            "td",
            [
              _c("Address", {
                attrs: {
                  "show-map": _vm.showMap,
                  address: _vm.saveGet(_vm.licence, null, "address")
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.$t("website")))]),
          _vm._v(" "),
          _c("td", [
            _vm.website !== "-"
              ? _c("a", { attrs: { href: _vm.website } }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.website) + "\n          "
                  )
                ])
              : _c("span", [
                  _vm._v(
                    "\n            " + _vm._s(_vm.website) + "\n          "
                  )
                ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.$t("license_key")))]),
          _vm._v(" "),
          _c("td", [
            _vm._v(_vm._s(_vm.saveGet(_vm.licence, "-", "licenceKey")))
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.$t("license_type")))]),
          _vm._v(" "),
          _c("td", [
            _vm._v(_vm._s(_vm.saveGet(_vm.licence, "-", "licenceType")))
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _vm._v(_vm._s(_vm.$t("licensing_gs1_member_organisation")))
          ]),
          _vm._v(" "),
          _c("td", { staticStyle: { "border-bottom": "none" } }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.saveGet(_vm.licence, "-", "licensingMO", "moName")) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.$t("last_update")))]),
          _vm._v(" "),
          _c("td", { staticStyle: { "border-bottom": "none" } }, [
            _vm._v(_vm._s(_vm.dateUpdated))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-545a23d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-545a23d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Licence.vue
// module id = null
// module chunks = 